import React from "react";
import ProgramTemplate from "@/components/ProgramTemplate";
import { PROGRAM_CI_RIF_78 } from "@/lib/programs/ciudadesImperialesRif78";

export default function CiudadesImperialesRif78Page() {
  return <ProgramTemplate program={PROGRAM_CI_RIF_78} variant="ci" showJourneyChronology />;
}
